function scrollTo(root = document) {
	const anchors = root.querySelectorAll('a[href]');
	[].forEach.call(anchors, anchor => {
		let href = anchor.getAttribute('href');
		if (href.charAt(0) === '#' && href.length > 1) {
			href = href.substring(1, href.length);
			anchor.addEventListener("click", function (e) {
				e.preventDefault();
				const hrefElement = root.querySelector('#' + href);
				// document.documentElement.scrollTop = getOffsetTop(hrefElement) - 140;
				// document.scrollingElement.scrollTop = getOffsetTop(hrefElement) - 140;
				$('html, body').animate({
					scrollTop: getOffsetTop(hrefElement) - 140
				}, 1000);
				hrefElement.focus();
			});
		}
	})
}
export function getOffsetTop(elem) {
	if (elem) {
		var offsetTop = 0;
		do {
			if (!isNaN(elem.offsetTop)) {
				offsetTop += elem.offsetTop;
			}
		} while (elem = elem.offsetParent);
		return offsetTop;
	}
}

export default scrollTo;
